import { api } from '../services';

// @todo: use case for user don't exists
async function acceptTerms(email) {
  const response = await api.acceptTerms(email);

  return { success: response.ok, data: response.data };
}

export default acceptTerms;
